'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = sliders;

var _constants = require('redux/constants');

var _sliders = require('redux/constants/sliders');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
    products_novelty: [],
    products_popular: [],
    products_hits: [],
    category: []
};

function sliders() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {

        case _constants.SliderConstants.SLIDER_LOAD:
        case _constants.SliderConstants.SLIDER_LOAD_CATEGORY:
            return state;

        case _constants.SliderConstants.SLIDER_LOAD_SUCCESS:

            if (action.result.sliderType === _sliders.SLIDER_NEW) {
                return (0, _extends3.default)({}, state, {
                    products_novelty: [].concat((0, _toConsumableArray3.default)(action.result.offers))
                });
            }
            if (action.result.sliderType === _sliders.SLIDER_POPULAR) {
                return (0, _extends3.default)({}, state, {
                    products_popular: [].concat((0, _toConsumableArray3.default)(action.result.offers))
                });
            }
            if (action.result.sliderType === _sliders.SLIDER_HIT) {
                return (0, _extends3.default)({}, state, {
                    products_hits: [].concat((0, _toConsumableArray3.default)(action.result.offers))
                });
            }
            return state;

        case _constants.SliderConstants.SLIDER_LOAD_CATEGORY_SUCCESS:
            return (0, _extends3.default)({}, state, {
                category: [].concat((0, _toConsumableArray3.default)(action.result.category))
            });

        case _constants.SliderConstants.SLIDER_LOAD_FAIL:
        case _constants.SliderConstants.SLIDER_LOAD_CATEGORY_FAIL:
            return state;

        default:
            return state;
    }
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/reducers/sliders.js
// module id = 1914
// module chunks = 0